export const showComments = buzz => buzz.flags.comments_enabled === 1;
